import logo from './logo.svg';
import { lazy, Suspense } from 'react';
import './css/App.css';
import { AuthProvider } from './AuthContext';

import Contact from "./Contact"
import About from "./About"
import { LoginComponent } from "./LoginComponent"
import { Propose } from "./Propose";
import { DataProvider } from './DataProviderContext';
import MultiView from "./dataview/MultiView";
import Register from "./Register"
import Layout from './Layout'; // The layout that includes ButtonAppBar
import JourneyImportPage from './JourneyImportPage';
import LandingPage from './LandingPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import EarlyAccessPage from './EarlyAccessPage';
import HowToUse from './HowToUse';
import WebAppGuide from './WebAppGuide';
import EmailVerificationRequired from './EmailVerificationRequired';
import ProtectedRoute from './ProtectedRoute';
import FeedbackPage from './FeedbackPage';
import TemplatesPage from './templates/TemplatesPage';
import TemplatePreviewPage from './templates/TemplatePreviewPage';
import InterviewPage from './InterviewPage';
import InterviewAdminPage from './InterviewAdminPage';
import InterviewInvitationPage from './InterviewInvitationPage';



import { Navigate, Routes, Route } from "react-router-dom"
import TestSlider from './random/TestSlider';
import { LEGACY_ROUTES, ROUTES } from './routes';

const GuideBotPage = lazy(() => import('./guide-bot/GuideBotPage'));
const ClaraBriefPage = lazy(() => import('./clara/ClaraBriefPage'));

function App() {

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" height='50' width='50' />

      </header>
      <AuthProvider>
        <DataProvider>
          <Routes>
            <Route path={ROUTES.root} element={<Layout />}>
              <Route index element={<LandingPage />} />
              <Route path={ROUTES.guideBot.slice(1)} element={<Suspense fallback={<p>Loading Alex…</p>}><GuideBotPage /></Suspense>} />
              <Route path={ROUTES.claraConfigure.slice(1)} element={<Suspense fallback={<p>Loading Clara…</p>}><ClaraBriefPage /></Suspense>} />
              <Route path={ROUTES.about.slice(1)} element={<About />} />
              <Route path={ROUTES.waysToUseChatGpt.slice(1)} element={<HowToUse />} />
              <Route path={ROUTES.waysToUseWebApp.slice(1)} element={<WebAppGuide />} />
              <Route path={ROUTES.howToUse.slice(1)} element={<Navigate to={ROUTES.waysToUseChatGpt} replace />} />
              <Route path={ROUTES.contact.slice(1)} element={<Contact />} />
              <Route path={ROUTES.register.slice(1)} element={<Register />} />
              <Route path={ROUTES.login.slice(1)} element={<LoginComponent />} />
              <Route path={ROUTES.verifyEmail.slice(1)} element={<EmailVerificationRequired />} />
              <Route path={ROUTES.terms.slice(1)} element={<TermsOfUse />} />
              <Route path={ROUTES.privacy.slice(1)} element={<PrivacyPolicy />} />
              <Route path={ROUTES.earlyAccess.slice(1)} element={<EarlyAccessPage />} />
              <Route path={ROUTES.profile.slice(1)} element={<Contact />} />
              <Route path={ROUTES.confirm.slice(1)} element={<Contact />} />
              <Route path={ROUTES.feedback.slice(1)} element={<FeedbackPage />} />
              <Route path={ROUTES.templates.slice(1)} element={<TemplatesPage />} />
              <Route path={ROUTES.templatePreview.slice(1)} element={<TemplatePreviewPage />} />
              <Route path={ROUTES.propose.slice(1)} element={<Propose />} />
              <Route path={ROUTES.journeyImport.slice(1)} element={<ProtectedRoute><JourneyImportPage /></ProtectedRoute>} />
              <Route path="interview/:id" element={<ProtectedRoute><InterviewPage /></ProtectedRoute>} />
              <Route path="interview/invite/:invitationId" element={<ProtectedRoute><InterviewInvitationPage /></ProtectedRoute>} />
              <Route path="interviews/admin" element={<ProtectedRoute><InterviewAdminPage /></ProtectedRoute>} />
              <Route path={ROUTES.mainView.slice(1)} caseSensitive element={<MultiView source="go" />} />
              <Route path={ROUTES.slider.slice(1)} caseSensitive element={<TestSlider />} />
              <Route path={LEGACY_ROUTES.mainView.slice(1)} element={<Navigate to={ROUTES.mainView} replace />} />
              <Route path={LEGACY_ROUTES.slider.slice(1)} element={<Navigate to={ROUTES.slider} replace />} />
              {/* multi view should have a parameter tell it which journey it should load 
            
            
            */}
            </Route>
          </Routes>
        </DataProvider>
      </AuthProvider>
    </div>

  );
}

export default App;

